// To add new ones, check https://fontawesome.com/v4.7.0/icons/

export const ICON_CLASS_MAP = {
  add: "fa fa-plus-circle",
  asterisk: "fa fa-asterisk",
  back: "fa fa-arrow-circle-left",
  basic_data: "fa fa-address-card",
  building: "fa fa-building",
  calendar: "fa fa-calendar",
  calendar_check: "fa fa-calendar-check-o",
  calendar_minus: "fa fa-calendar-minus-o",
  calendar_plus: "fa fa-calendar-plus-o",
  calendar_times: "fa fa-calendar-times-o",
  chart_pie: "fa fa-pie-chart",
  chart_line: "fa fa-line-chart",
  clock: "fa fa-clock-o",
  confirm: "fa fa-check-circle",
  curriculum: "fa fa-address-card",
  comments: "fa fa-comments",
  down: "fa fa-chevron-down",
  download: "fa fa-cloud-download",
  error: "fa fa-times-circle",
  exam: "fa fa-pencil-square-o",
  exam_objective: "fa fa-pencil-square-o",
  exam_practical: "fa fa-heartbeat",
  exclamation: "fa fa-exclamation-triangle",
  expand_down: "fa fa-angle-double-down",
  file: "fa fa-file",
  file_ms_word: "fa fa-file-word-o",
  file_ms_excel: "fa fa-file-excel-o",
  file_ms_powerpoint: "fa fa-file-powerpoint-o",
  file_image: "fa fa-picture-o",
  file_text: "fa fa-file-text",
  file_pdf: "fa fa-file-pdf-o",
  files: "fa fa-clone",
  github: "fa fa-github",
  globe: "fa fa-globe",
  graduation: "fa fa-graduation-cap",
  handshake: "fa fa-handshake-o",
  heart: "fa fa-heart",
  home: "fa fa-home",
  id_card: "fa fa-id-badge",
  info: "fa fa-info-circle",
  instagram: "fa fa-instagram",
  institution: "fa fa-institution",
  linkedin: "fa fa-linkedin",
  map: "fa fa-map-o",
  mail: "fa fa-envelope",
  menu: "fa fa-bars",
  microphone: "fa fa-microphone",
  minus: "fa fa-minus-circle",
  money: "fa fa-dollar",
  question: "fa fa-question-circle",
  results_final: "fa fa-trophy",
  results_objective: "fa fa-area-chart",
  results_practical: "fa fa-bar-chart",
  socioeconomic: "fa fa-balance-scale",
  success: "fa fa-check-circle",
  social_assistance: "fa fa-universal-access",
  times: "fa fa-times-circle",
  user: "fa fa-user-circle",
  users: "fa fa-users",
  user_plus: "fa fa-user-plus",
  user_times: "fa fa-user-times",
  warning: "fa fa-warning",
};

export default ICON_CLASS_MAP;
